<template>
<div class="chapter">
<div class="inner_page">
      ﻿

    
        <title>TOC</title>
<link href="stylesheet.css" rel="stylesheet" type="text/css"/>
<h1 style="text-align:center;"><br/> TABLE OF CONTENTS </h1>
<table cellpadding="2" cellspacing="2">
<colgroup><col style="text-align:right;"/>
<col style="text-align:left;"/>
</colgroup><tbody><tr>
<td>5</td>
<td>
<a href="#/chapter5">Introduction</a>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<a href="#/chapter6">1. Angelica</a>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<a href="#/chapter7">2. Anise</a>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<a href="#/chapter8">3. Basil</a>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter9" title="Link target outside of Sample">4. Bay Laurel</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter10" title="Link target outside of Sample">5. Bergamot (Scarlet)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter11" title="Link target outside of Sample">6. Betony</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter12" title="Link target outside of Sample">7. Bistort</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter13" title="Link target outside of Sample">8. Borage</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter14" title="Link target outside of Sample">9. Burnet (Salad)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter15" title="Link target outside of Sample">10. Caraway</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter16" title="Link target outside of Sample">11. Chamomile (German)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter17" title="Link target outside of Sample">13. Chervil</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter18" title="Link target outside of Sample">14. Chives</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter19" title="Link target outside of Sample">15. Cilantro (Coriander)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter20" title="Link target outside of Sample">16. Clary Sage</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter21" title="Link target outside of Sample">17. Comfrey (Russian)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter22" title="Link target outside of Sample">18. Costmary</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter23" title="Link target outside of Sample">19. Cumin</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter24" title="Link target outside of Sample">20. Curry Plant</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter25" title="Link target outside of Sample">21. Dandelion</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter26" title="Link target outside of Sample">22. Dill</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter27" title="Link target outside of Sample">23. Dock (Blood-veined)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter28" title="Link target outside of Sample">25. Elecampane</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter29" title="Link target outside of Sample">26. Epazote</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter30" title="Link target outside of Sample">27. Fennel</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter31" title="Link target outside of Sample">28. Fenugreek</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter32" title="Link target outside of Sample">29. Feverfew</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter33" title="Link target outside of Sample">31. Garden Cress</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter34" title="Link target outside of Sample">34. Garlic</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter35" title="Link target outside of Sample">35. Good King Henry</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter36" title="Link target outside of Sample">36. Horehound</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter37" title="Link target outside of Sample">37. Horseradish</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter38" title="Link target outside of Sample">38. Hyssop</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter39" title="Link target outside of Sample">39. Lavender</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter40" title="Link target outside of Sample">40. Lemon Balm ‘All Gold’</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter41" title="Link target outside of Sample">41. Lemongrass</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter42" title="Link target outside of Sample">42. Lemon Verbena</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter43" title="Link target outside of Sample">43. Licorice</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter44" title="Link target outside of Sample">44. Lovage</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter45" title="Link target outside of Sample">45. Marigold</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter46" title="Link target outside of Sample">46. Marjoram ‘Creeping Golden’</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter47" title="Link target outside of Sample">49. Marsh Mallow</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter48" title="Link target outside of Sample">50. Meadowsweet</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter49" title="Link target outside of Sample">51. Mullein (Great)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter50" title="Link target outside of Sample">52. Mustard</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter51" title="Link target outside of Sample">53. Parsley (Curly-leaved)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter52" title="Link target outside of Sample">55. Peppermint</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter53" title="Link target outside of Sample">57. Purslane (Golden)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter54" title="Link target outside of Sample">58. Rampion</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter55" title="Link target outside of Sample">59. Rocket (Arugula)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter56" title="Link target outside of Sample">60. Rosemary</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter57" title="Link target outside of Sample">61. Rue</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter58" title="Link target outside of Sample">62. Saffron</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter59" title="Link target outside of Sample">63. Sage (Golden)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter60" title="Link target outside of Sample">65. Shiso (Purple)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter61" title="Link target outside of Sample">66. Soapwort</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter62" title="Link target outside of Sample">67. Savory (Summer)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter63" title="Link target outside of Sample">69. Stevia</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter64" title="Link target outside of Sample">70. Tarragon (French)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter65" title="Link target outside of Sample">71. Thyme (Garden)</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter66" title="Link target outside of Sample">73. Wormwood</span>
</div>
</td>
</tr>
<tr>
<td>67</td>
<td>
<span href="#/chapter67" title="Link target outside of Sample">Bibliography</span>
</td>
</tr>
<tr>
<td>68</td>
<td>
<span href="#/chapter68" title="Link target outside of Sample">Resources</span>
</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?e47596c6